// Rupee amount in words (Indian numbering): 210 -> "Rupees Two Hundred Ten Only", 1250.5 -> "... and Fifty Paise Only".
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
  "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function upto99(n) {
  return n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]}${n % 10 ? ` ${ONES[n % 10]}` : ""}`;
}

function upto999(n) {
  const h = Math.floor(n / 100), r = n % 100;
  return [h ? `${ONES[h]} Hundred` : "", r ? upto99(r) : ""].filter(Boolean).join(" ");
}

function words(n) {
  if (n === 0) return "Zero";
  const parts = [];
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  if (crore) parts.push(`${words(crore)} Crore`);
  if (lakh) parts.push(`${upto99(lakh)} Lakh`);
  if (thousand) parts.push(`${upto99(thousand)} Thousand`);
  if (n) parts.push(upto999(n));
  return parts.join(" ");
}

export function amountInWords(amount) {
  const value = Math.round((Number(amount) || 0) * 100);
  const rupees = Math.floor(value / 100), paise = value % 100;
  return `Rupees ${words(rupees)}${paise ? ` and ${upto99(paise)} Paise` : ""} Only`;
}
